@import '../../../../constants/spacing.module.less';

.wrapper {
  align-items: center;
  align-self: stretch;
}

.with-divider {
  padding-left: @space-16;
}
